// eslint-disable-next-line import/prefer-default-export
export const BASE_FPS_BODY = {
  cpuOC: 1,
  gpuNumber: 1,
  gpuType: 'desktop',
  memchannels: 2,
  memfrequency: 3200,
};
